import { View } from './view'

export const Burger = View
